import React from 'react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../components/Formik/FormikControl'
import Button from '@mui/material/Button'
import { useDispatch, useSelector } from 'react-redux'
import { login } from '../actions/auth'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import Avatar from '@mui/material/Avatar'
import { Card, CardContent } from '@mui/material'
import { RootState } from '../reducers'
import { ValuesSubmitStudentLogin } from '../types'

const LogInScreen: React.FC = () => {
  const initialValues = {
    email: '',
    password: '',
  }

  const dispatch = useDispatch()
  const auth = useSelector((state: RootState) => state.auth)

  const { isAuthenticated, user } = auth

  let history = useHistory()
  let location = useLocation()

  const { from }: any = location.state || { from: { pathname: "/dashboard" } }

  const validationSchema = Yup.object({
    email: Yup.string()
      .email('Email không đúng')
      .required('Không được để trống'),
    password: Yup.string().required('Không được để trống'),
  })

  const onSubmit = async (values: ValuesSubmitStudentLogin) => {
    const { email, password } = values

    dispatch(login(email, password))
  }

  if (isAuthenticated && user && from === "/dashboard") {
    history.replace(from)
  } else if (isAuthenticated && user && from !== "/dashboard") {
    history.replace(from)
  }

  return (
    <div className='container' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Card style={{ maxWidth: '80%' }}>
        <CardContent>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            direction="column"
          >
            <Grid item style={{ marginTop: '0.5em' }}>
              <Avatar>
                <LockOpenIcon />
              </Avatar>
            </Grid>
            <Grid item>
              <Typography variant="h4" gutterBottom style={{ textTransform: 'uppercase', margin: '0.5em 0' }}>
                Đăng nhập tài khoản học sinh
              </Typography>
            </Grid>
            <Grid item>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {(formik) => {
                  return (
                    <Form>
                      <FormikControl
                        control="input"
                        type="email"
                        label="Email"
                        name="email"
                        style={{ marginBottom: '1em' }}
                      />
                      <FormikControl
                        control="input"
                        type="password"
                        label="Password"
                        name="password"
                        style={{ marginBottom: '1em' }}
                      />
                      <Button
                        fullWidth
                        color="primary"
                        variant="contained"
                        type="submit"
                        disabled={!formik.isValid}
                        style={{ color: 'white' }}
                      >
                        Đăng nhập
                      </Button>
                      <Grid
                        container
                        alignItems="center"
                        justifyContent="center"
                        style={{ margin: '0.5em 0' }}
                      >
                        <Grid item>
                          <Typography variant="body1">
                            Bạn chưa có tài khoản?
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Button
                            component={Link}
                            to="/register-user"
                            variant="text"
                            style={{
                              fontSize: '1rem',
                              textTransform: 'none',
                              fontWeight: 600,
                            }}
                            disableRipple
                          >
                            Đăng ký
                          </Button>
                        </Grid>
                      </Grid>
                    </Form>
                  );
                }}
              </Formik>
            </Grid>

            {!isAuthenticated && from.pathname === "/teachers/english" && <Grid>
              <Typography variant='body1' style={{ color: 'red', fontWeight: 500 }}>Vui lòng đăng nhập trước khi đến trang "Tìm một giáo viên"</Typography>
            </Grid>}

          </Grid>
        </CardContent>
      </Card>
    </div>
  );
}

export default LogInScreen
